module.exports = __webpack_public_path__ + "static/media/c20.a7de5b3d.png";